<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/HbaRPp/tc-custom/9781035847419.jpg?1718183631947" alt="This image is the cover for the book Homeless Companions"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Homeless Companions
      </h1>
      <p class="bookDescription body article font2">
        <p>Harmony Harringdon is a teenager with her whole life ahead of her. She is beautiful, sweet, and talented. Harmony and her best friend Jake Butler are inseparable. As the pair grow from children to teenagers, their friendship becomes love. They weren’t to know what fate has planned for them. It would all become too much for Harmony, despite having Jake there to support her. Fleeing the shame and devastation she believes she has caused, Harmony leaves all she knows behind her. Bearing witness to the cruel realities of life, this time fate is kind and brings Harmony a Carnival. With newfound purpose, Harmony’s talent and tenacity propels her on an unexpected journey. However, all Harmony longs for more than anything is for something or someone to save her.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kim Godden
      </h2>
      
      <p class="authorDescription body article">As well as being a working mother of three, Kim Godden has tirelessly strived to bring her work to life with the power of words. Taking inspiration from the world around her has enabled her to challenge topics within her novels and bring new perspectives to her readers.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b4f239d0